


























import Vue from "vue";
import { testMethod } from "../services/api/api";
import Nav from "../App.vue";

export default Vue.extend({
  name: "HelloWorld",
  data: function() {
    return {
      serverMessage: ""
    };
  },
  methods: {
    helloWorld: async function() {
      this.serverMessage = await testMethod();

      return;
    },

    login: Nav.methods.login
  }
});
